export default "__VITE_ASSET__DXm0LraJ__"